export const SET_EVENT_FORM = "EVENTS/SET_EVENT_FORM" 
export const ADD_BATCHFROMBATCHES = "EVENTS/ADD_BATCHFROMBATCHES" 
export const SET_BATCHFROMBATCHES = "EVENTS/SET_BATCHFROMBATCHES" 
export const REMOVE_BATCH_FROM_BATCHES = "EVENTS/REMOVE_BATCH_FROM_BATCHES" 
export const EDIT_BATCH_FROM_BATCHES = "EVENTS/EDIT_BATCH_FROM_BATCHES" 
export const SET_MYEVENTS = "EVENTS/SET_MYEVENTS" 
export const SET_EVENT = "EVENTS/SET_EVENT" 
export const UPDATE_EVENT = "EVENTS/UPDATE_EVENT" 
export const RESET_EVENT_FORM = "EVENTS/RESET_EVENT_FORM" 
export const UPDATE_EVENT_BALANCE = "EVENTS/UPDATE_EVENT_BALANCE" 
export const RESET_MYEVENTS = "EVENTS/RESET_MYEVENTS" 
export const SET_UPDATED_EVENT = "EVENTS/SET_UPDATED_EVENT" 